import { Warehouse } from '@phosphor-icons/react';
import { Select } from '@skupreme/shared/ui';

export type ProviderOption = {
  value: string;
  label: string;
  description?: string;
  availability?: string;
  isOutOfStock?: boolean;
  /** Shown in place of the warehouse icon, e.g. Amazon's for Amazon MCF. */
  logoUrl?: string;
};

export type ShipFromSelectProps = {
  options: ProviderOption[];
  value?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  onChange: (providerId: string) => void;
};

/** The warehouse a shipment leaves from, the one field every shipment has. */
export function ShipFromSelect({
  options,
  value,
  isLoading,
  isDisabled,
  onChange,
}: ShipFromSelectProps) {
  return (
    <Select
      aria-label="Ship from"
      options={options.map(option => ({
        value: option.value,
        label: option.label,
        description: option.description,
        leading: (
          <span className="sk:flex sk:size-8 sk:items-center sk:justify-center sk:rounded-full sk:bg-fill-secondary sk:text-fg-secondary">
            {option.logoUrl ? (
              <img
                src={option.logoUrl}
                alt=""
                className="sk:size-5 sk:rounded-xs sk:object-contain"
              />
            ) : (
              <Warehouse size={16} weight="duotone" />
            )}
          </span>
        ),
        trailing: option.availability ? (
          <span
            className={
              option.isOutOfStock
                ? 'sk:text-xs sk:text-danger'
                : 'sk:text-xs sk:text-fg-secondary'
            }
          >
            {option.availability}
          </span>
        ) : undefined,
      }))}
      value={value || ''}
      placeholder={isLoading ? 'Loading warehouses' : 'Select warehouse'}
      isDisabled={isDisabled || options.length === 0}
      className="sk:h-auto sk:min-h-12 sk:w-full sk:rounded-card sk:py-2"
      popoverClassName="sk:min-w-80"
      onChange={onChange}
    />
  );
}
